// src/components/AboutHero/AboutHero.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import './AboutHero.css';

const AboutHero = () => {


  return (
    <section className="about-hero-section">

      <Container>
        <Row>
          <Col lg={12}>
            <div className="about-hero-content">
              {/* Main Title: About (Regular) Us (Bold) */}
              <h1 className="about-hero-title">
                About <span>Us</span>
              </h1>

            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutHero;